// Hungry Canadian Brand Assets
// Central configuration for logos, images, and brand URLs.
// ALL asset URLs should be imported from here — never hardcoded in components.

const PORTAL_LOGO_URL = 'https://customer-assets.emergentagent.com/job_restaurant-portal-22/artifacts/0d8m48ci_HungryCanadian%20Logo_red_white_%202026_2000x1000.png';

export const LOGOS = {
  // For light/white backgrounds - Red HUNGRY + Black CANADIAN
  LIGHT_BG: "https://customer-assets.emergentagent.com/job_63cb306a-d6c6-4303-b23a-331841c3e4c0/artifacts/ffd46v7c_HungryCanadian%20Logo%202026_2000x1000.png",

  // For light backgrounds - all black text
  LIGHT_BG_BLACK: "https://customer-assets.emergentagent.com/job_63cb306a-d6c6-4303-b23a-331841c3e4c0/artifacts/ntrf1qcz_HungryCanadian%20Logo%202026_All_Black_2000x1000.png",

  // For dark backgrounds - all white text
  DARK_BG: "https://customer-assets.emergentagent.com/job_63cb306a-d6c6-4303-b23a-331841c3e4c0/artifacts/jwwksdv0_HungryCanadian%20Logo_2026_All_White_2000x1000.png",

  // For dark backgrounds - red HUNGRY, white CANADIAN (primary portal logo)
  COLOR_DARK: PORTAL_LOGO_URL,

  // Color version on black background
  COLOR_BLACK_BG: "https://customer-assets.emergentagent.com/job_63cb306a-d6c6-4303-b23a-331841c3e4c0/artifacts/mr4mat1o_HungryCanadian%20Logo%202026_Black_Background_2000x1000.png",

  // Portal convenience aliases (use these in components)
  PORTAL_DARK: PORTAL_LOGO_URL,
  PORTAL_LIGHT: "https://customer-assets.emergentagent.com/job_63cb306a-d6c6-4303-b23a-331841c3e4c0/artifacts/ffd46v7c_HungryCanadian%20Logo%202026_2000x1000.png",
};

export const IMAGES = {
  LOGIN_HERO: 'https://images.unsplash.com/photo-1767785990437-dfe1fe516fe8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxyZXN0YXVyYW50JTIwa2l0Y2hlbiUyMGNoZWYlMjBjb29raW5nfGVufDB8fHx8MTc3MzQ1MDQyNHww&ixlib=rb-4.1.0&q=85',

  // ─────────────────────────────────────────────────────────────────────
  // /join (public self-discovery page) imagery.
  // Keys are semantic, not positional — any section can reference any key.
  // ─────────────────────────────────────────────────────────────────────
  JOIN: {
    // Wide restaurant interior: owner at counter using a tablet, with cafe
    // seating on one side and active kitchen on the other. Used as the hero
    // background with a uniform dark overlay. Cinematic framing keeps the
    // owner in focus at wide/desktop crops.
    OWNER_WITH_TABLET:
      'https://customer-assets.emergentagent.com/job_d366b569-2d4e-478d-bc1f-d87ae2bf3412/artifacts/hi092mzk_Gemini_Generated_Image_eq7n1qeq7n1qeq7n.png',

    // Wide panoramic: pickup window + owner handoff + driver loading car.
    // Used as the "Built for businesses like yours" cinematic banner.
    STOREFRONT_PANORAMA:
      'https://customer-assets.emergentagent.com/job_d366b569-2d4e-478d-bc1f-d87ae2bf3412/artifacts/ctcinqnf_Gemini_Generated_Image_jtb8fmjtb8fmjtb8.png',

    // Owner + team member reviewing menu on tablet in a warm cafe setting.
    // Used as the "Support & merchant resources" side image.
    MENU_REVIEW:
      'https://customer-assets.emergentagent.com/job_d366b569-2d4e-478d-bc1f-d87ae2bf3412/artifacts/fy4uam1h_Gemini_Generated_Image_31gjd331gjd331gj.png',

    // Kitchen counter with HC-branded bags and fresh food. Reserved for
    // future use (launch kit / packaging section).
    KITCHEN_COUNTER_BRANDED:
      'https://customer-assets.emergentagent.com/job_d366b569-2d4e-478d-bc1f-d87ae2bf3412/artifacts/0d4ky6rp_Gemini_Generated_Image_id3pjiid3pjiid3p.png',

    // Stylised red monochrome product still-life. Reserved for future use
    // (background accent / brand-moment imagery).
    ABSTRACT_RED:
      'https://customer-assets.emergentagent.com/job_d366b569-2d4e-478d-bc1f-d87ae2bf3412/artifacts/t90zte3z_Gemini_Generated_Image_eaigsyeaigsyeaig.png',
  },
};

export const BRAND = {
  name: "Hungry Canadian",
  website: "https://hungrycanadian.com",
  supportEmail: "support@hungrycanadian.ca",
  merchantsEmail: "merchants@hungrycanadian.com",
  copyrightYear: new Date().getFullYear(),
};

// Helper: get the correct logo for the current theme
export const getLogoForTheme = (theme) =>
  theme === 'dark' ? LOGOS.PORTAL_DARK : LOGOS.PORTAL_LIGHT;

export default { LOGOS, IMAGES, BRAND, getLogoForTheme };
